import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { CommonService } from 'src/app/core/services/common.service';
import { Constant } from 'src/app/core/services/constant';
import { HttpService } from 'src/app/core/services/http.service';
import { apiUrls } from 'src/app/core/services/urlList/apiUrls';
import { DialogService } from 'src/app/dialog/dialog.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  viewType: any = [];
  isActive1: boolean = false;
  isActive2: boolean = false;
  isActive3: boolean = false;
  isActive4: boolean = false;
  isActive5: boolean = false;
  issetLocal$: Subject<any> = new Subject<any>();
  destroy$: Subject<boolean> = new Subject<boolean>();
  singleType: string;
  type: Array<any> = [];
  moduleData: any;
  role: string;
  isMenuCollapsed: boolean = true;

  toggleMenu() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
  }
  constructor(
    private router: Router,
    private comm: CommonService,
    private http: HttpService,
    private api: apiUrls,
    private constant: Constant,
    private route: ActivatedRoute,
    private dialogService: DialogService
  ) {

    this.role= localStorage.getItem('role') || '';
    switch(this.role){
      case 'sales':
        this.moduleData = [...this.constant.Sales_Modules];
        break;
      default :
      this.moduleData = [...this.constant.MODULES];
    }     
  }

  ngOnInit(): void {
    const savedType = localStorage.getItem('viewType');
    if (savedType) {
      try {
        this.type = JSON.parse(savedType);
      } catch (e) {}
    }
    const savedViewType = localStorage.getItem('setViewType');
    if (savedViewType) {
      try {
        this.singleType = JSON.parse(savedViewType);
      } catch (e) {
        this.singleType = savedViewType;
      }
    } else if (this.type && this.type.length > 0) {
      this.singleType = this.type[0].value;
    }

    this.issetLocal$.pipe(take(1)).subscribe((res) => {
      if (res) {
        if (localStorage.getItem('viewType')) {
          try {
            this.type = JSON.parse(localStorage.getItem('viewType') || '');
          } catch (e) {}
        }
        const sv = localStorage.getItem('setViewType');
        if (sv) {
          try {
            this.singleType = JSON.parse(sv);
          } catch (e) {
            this.singleType = sv;
          }
        }
      }
    });
    this.getViewType();
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  changeViewType(type: any) {
    if (type) {
      this.isMenuCollapsed = true;
      this.router.navigate(['/client/list']);
      localStorage.setItem('setViewType', JSON.stringify(type.value));
      this.comm.isTypeChanged$.next(true);
    }
  }

  redirect(route:any){
    this.isMenuCollapsed = true;
    this.router.navigate([route.route], route.isQueryParams?{queryParams:{role:this.role}}:{})
  }

  isActiveRoute(route: string): boolean {
    if (!route) return false;
    const currentUrl = this.router.url.split('?')[0];
    if (route === '/dashboard') {
      return currentUrl === '/dashboard';
    }
    if (route === '/client/list') {
      return currentUrl.startsWith('/client') && !currentUrl.includes('onboard-list');
    }
    if (route === '/client/onboard-list') {
      return currentUrl.includes('onboard-list');
    }
    if (route === '/subscription/list') {
      return currentUrl.startsWith('/subscription');
    }
    if (route === '/module/list') {
      return currentUrl.startsWith('/module');
    }
    if (route === '/extension/list') {
      return currentUrl.startsWith('/extension');
    }
    if (route === '/feature/list') {
      return currentUrl.startsWith('/feature');
    }
    if (route === '/sub-Admin/list') {
      return currentUrl.toLowerCase().startsWith('/sub-admin');
    }
    return currentUrl.startsWith(route);
  }

  logout() {
    this.dialogService.openLogoutDialog();
  }

  getViewType() {
    this.http
      .get(this.api.getView)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res['response']['success'] && res.data && res.data.length > 0) {
          this.viewType = res.data;
          localStorage.setItem('viewType', JSON.stringify(this.viewType));
          const existingSetViewType = localStorage.getItem('setViewType');
          if (!existingSetViewType) {
            localStorage.setItem(
              'setViewType',
              JSON.stringify(this.viewType[0].value)
            );
          }
          this.issetLocal$.next(true);
          this.type = this.viewType;
          const savedViewType = localStorage.getItem('setViewType');
          if (savedViewType) {
            try {
              this.singleType = JSON.parse(savedViewType);
            } catch (e) {
              this.singleType = savedViewType;
            }
          }
        }
      });
  }

  getSelectedViewTypeLabel(): string {
    if (this.type && this.type.length > 0 && this.singleType) {
      const selectedItem = this.type.find((item) => item.value === this.singleType);
      if (selectedItem) {
        return this.formatViewType(selectedItem);
      }
    }
    return this.formatViewType({ value: this.singleType });
  }

  formatViewType(item: any): string {
    if (!item) return '';
    const key = (item.key || '').toString();
    const val = (item.value || '').toString();
    const combined = (key + ' ' + val).toLowerCase();

    if (combined.includes('ondemand') || combined.includes('on-demand') || combined.includes('on_demand')) {
      return 'ON-DEMAND';
    }
    if (combined.includes('pnd') || combined.includes('p&d')) {
      return 'P&D';
    }
    return (item.key ? item.key.split('_')[1] || item.key : item.value || '').toString().trim();
  }
}
